import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import CopyToClipboard from "src/components/shared/CopyToClipboard";
import { orderStatusFormatted, orderTrackingType, payloadFilter, WAREHOUSE_OPTIONS_TRANSLATE, WAREHOUSE_STATUS_TRANSLATE } from "src/constant";
import useWarehouseTransferList from "src/hooks/warehouse-transfer/useWarehouseTransferList";
import { v4 as uuid } from "uuid";
import ExportActionGroup from "../ExportActionGroup";
import useQueryParams from "src/hooks/useQueryParams";
import ExportConfirmActionGroup from "../ExportConfirmActionGroup";
import ProcessingBadge from "src/components/shared/ProcessingBagde";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/vi";
import useAuthGlobal from "src/context/useAuthGlobal";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
dayjs.extend(relativeTime);
dayjs.locale("vi");

export default function useInventoryOutBody({ date, topbarSearchList, keyword, searchBy, paramsQuery, warehouseId }) {
  const permissionCheck = useRoleCheck();
  const { userMe } = useAuthGlobal();
  const [option] = useQueryParams();
  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });

  const query = {
    ...paramsQuery,
    statusOutType: undefined,
  };
  const {
    data: inventoryOut,
    isLoading,
    error,
  } = useWarehouseTransferList({
    ...pagi,
    ...payloadFilter,
    fromWarehouse: warehouseId ?? userMe?.currentWarehouse?._id,
    statusOut: option?.tab === "inventory-out-pending" ? "Pending" : undefined,
    // type: WAREHOUSE_MANAGEMENT_TYPE_POST[option?.tab] === orderTrackingType.remove ? orderTrackingType.remove : undefined,
    ...date,
    searchField: !!searchBy ? topbarSearchList[searchBy - 1]?.value : topbarSearchList[0]?.value,
    searchValue: !!keyword ? keyword : undefined,
    ...query,
  });

  const header = [
    {
      id: uuid(),
      title: "STT",
      align: "center",
    },
    {
      id: uuid(),
      title: "Mã PXK",
      align: "center",
      width: "100px",
    },
    {
      id: uuid(),
      title: "Hình thức Xuất",
      align: "center",
      width: "100px",
    },
    ...(permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN])
      ? [
          {
            id: uuid(),
            title: "Kho xuất",
            align: "center",
            width: "80px",
          },
        ]
      : []),
    {
      id: uuid(),
      title: "Kho nhận",
      align: "center",
      width: "100px",
    },
    {
      id: uuid(),
      title: "Trạng thái",
      align: "center",
      width: "80px",
    },
    {
      id: uuid(),
      title: "Hình thức thanh toán",
      align: "center",
      width: "80px",
    },
    {
      id: uuid(),
      title: "Xác nhận",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      align: "center",
    },
  ];

  const bodyList = Array.isArray(inventoryOut?.data)
    ? inventoryOut?.data?.map((v, index) => ({
        ...v,
        no: index + 1,
        innOutCode: v?.innOutCode ? <CopyToClipboard value={v?.innOutCode} /> : "-",
        typeStatus: (
          <Box>
            <ProcessingBadge
              value={!!v?.orderCode ? WAREHOUSE_OPTIONS_TRANSLATE.Return : WAREHOUSE_OPTIONS_TRANSLATE[v?.type]}
              asset={{
                color: v?.type === orderTrackingType.new ? "confirm" : "pending",
                text: v?.type === orderTrackingType.new ? "confirm" : "pending",
              }}
            />
            {v?.orderCode && (
              <Typography
                sx={{
                  fontSize: "10px",
                  color: "var(--error)",
                  fontWeight: "bold",
                  pt: "4px",
                }}
              >
                {v?.orderCode}
              </Typography>
            )}
          </Box>
        ),
        toWarehouseName: (
          <Box>
            <Typography
              variant="body2"
              sx={{ whiteSpace: "nowrap" }}
            >
              {v?.toWarehouse?.name ?? "-"}
            </Typography>
            <Typography
              variant="body2"
              sx={{ whiteSpace: "nowrap" }}
            >
              {dayjs(v?.createdAt).format("DD-MM-YYYY")}
            </Typography>
          </Box>
        ),
        ...(permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]) && {
          fromWarehouseName: (
            <Box>
              <Typography
                variant="body2"
                sx={{ whiteSpace: "nowrap" }}
              >
                {v?.fromWarehouse?.name ?? "-"}
              </Typography>
              <Typography
                variant="body2"
                sx={{ whiteSpace: "nowrap" }}
              >
                {dayjs(v?.createdAt).format("DD-MM-YYYY")}
              </Typography>
              {!!v?.exportedAt && <Typography sx={{ fontSize: "10px" }}>({dayjs(v?.exportedAt).format("DD-MM-YYYY")})</Typography>}
            </Box>
          ),
        }),
        statusType: v?.statusOut ? (
          <ProcessingBadge
            value={WAREHOUSE_STATUS_TRANSLATE[v?.statusOut]}
            asset={{
              color: orderStatusFormatted.Exported === v?.statusOut ? "success" : "Exported",
              text: orderStatusFormatted.Exported === v?.statusOut ? "success" : "Exported",
            }}
          />
        ) : (
          "-"
        ),
        payment: v?.paymentMethod?.name,
        approve: <ExportConfirmActionGroup item={v} />,
        actionGroup: <ExportActionGroup item={v} />,
      }))
    : null;
  const sortData = [
    "no",
    "innOutCode",
    "typeStatus",
    "fromWarehouseName",
    "toWarehouseName",
    // "createdAt",
    "statusType",
    "payment",
    "approve",
    "actionGroup",
  ];
  return { header, error, isLoading, bodyList, sortData, setPagi };
}
